export  class  DWDefaultPaymentRequest
{
    walletId :string='';
    token :string='';
    sessionID:string='';
}